import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-virtualDevice-bulk-edit', {
    attrs: {
      "isOpen": _vm.showBulkEditAllDialog,
      "devices": _vm.devices,
      "isCalculating": _vm.isCalculating,
      "isCalculatingError": _vm.isCalculatingError,
      "belongToSameAccount": _vm.belongToSameAccount
    },
    on: {
      "close": function ($event) {
        return _vm.closeDialog();
      }
    }
  }), _c('core-virtualDevice-bulk-import', {
    attrs: {
      "isOpen": _vm.showBulkImportDialog
    },
    on: {
      "close": function ($event) {
        return _vm.closeDialogBulkImport();
      }
    }
  }), _c('core-virtual-device-dialog-statistics', {
    attrs: {
      "open": _vm.showDialogStatistics,
      "searchTypes": _vm.statisticsSearchTypes,
      "searchItems": [..._vm.searchItems],
      "selectedAccounts": _vm.selectedAccounts
    },
    on: {
      "close": function ($event) {
        _vm.showDialogStatistics = false;
      }
    }
  }), _vm.showDialogCreate ? _c('core-virtualDevice-add-wizard', {
    attrs: {
      "isOpen": _vm.showDialogCreate,
      "useDriver": _vm.isDeviceDriverActive
    },
    on: {
      "close": function ($event) {
        _vm.showDialogCreate = false;
      },
      "created": _vm.finishedCreating
    }
  }) : _vm._e(), _c('core-csv-export-dialog-multi', {
    attrs: {
      "isOpen": _vm.showExportDialog,
      "type": "virtualDevice"
    },
    on: {
      "close": function ($event) {
        _vm.showExportDialog = false;
      }
    }
  }), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('DigitalTwin.VirtualDevice.title'),
      "subtitle": _vm.$i18n_t('DigitalTwin.VirtualDevice.subTitle')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.showEditSelectedBtn ? [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": _vm.isBulkEditAllBtnDisabled,
            "prepend-icon": "fa-edit",
            "tooltip": _vm.bulkEditAllBtnDisabledTooltip
          },
          on: {
            "click": function ($event) {
              return _vm.showBulkEditDialog();
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.manageSelected')) + "\n        ")])] : _vm._e(), _vm.isMobile ? _c('span', [_c('core-button', {
          attrs: {
            "data-cy": "btn_create_vd",
            "color": _vm.color,
            "disabled": !_vm.isDeviceManager,
            "prepend-icon": "fa-plus"
          },
          on: {
            "click": function ($event) {
              _vm.showDialogCreate = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "data-cy": "vd_csv_export",
            "color": _vm.color,
            "prepend-icon": "fa-file-csv"
          },
          on: {
            "click": function ($event) {
              _vm.showExportDialog = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.isDeviceManager,
            "prepend-icon": "fa-star",
            "solid-icon": _vm.favouriteFilter
          },
          on: {
            "click": function ($event) {
              _vm.favouriteFilter = !_vm.favouriteFilter;
            }
          }
        }), _c('core-account-filter', {
          attrs: {
            "multiple": "",
            "iconOnly": "",
            "selected": _vm.setSelectedAccounts
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "ready": function ($event) {
              _vm.accountFilterReady = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-layer-plus",
            "disabled": !_vm.isDeviceManager
          },
          on: {
            "click": function ($event) {
              return _vm.showDialogBulkImport();
            }
          }
        }), _vm.hasAnyGeoDevices ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-map-marked-alt",
            "to": "/virtual-devices/map"
          }
        }) : _vm._e()], 1) : _c('span', [_c('core-button', {
          attrs: {
            "data-cy": "btn_create_vd",
            "color": _vm.color,
            "disabled": !_vm.isDeviceManager,
            "prepend-icon": "fa-plus"
          },
          on: {
            "click": function ($event) {
              _vm.showDialogCreate = true;
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.create')) + "\n        ")]), _c('core-button', {
          attrs: {
            "data-cy": "create_vd_bulk",
            "color": _vm.color,
            "prepend-icon": "fa-layer-plus"
          },
          on: {
            "click": _vm.showDialogBulkImport
          }
        }), _c('core-button', {
          attrs: {
            "data-cy": "csv_export",
            "color": _vm.color,
            "prepend-icon": "fa-file-csv"
          },
          on: {
            "click": function ($event) {
              _vm.showExportDialog = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "data-cy": "fav_btn",
            "color": _vm.color,
            "prepend-icon": "fa-star",
            "title": _vm.$i18n_t('Common.home.favorites'),
            "solid-icon": _vm.favouriteFilter
          },
          on: {
            "click": function ($event) {
              _vm.favouriteFilter = !_vm.favouriteFilter;
            }
          }
        }), _c('core-account-filter', {
          attrs: {
            "data-cy": "account_filter",
            "multiple": "",
            "selected": _vm.setSelectedAccounts
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "ready": function ($event) {
              _vm.accountFilterReady = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-chart-bar"
          },
          on: {
            "click": function ($event) {
              _vm.showDialogStatistics = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "data-cy": "loadmap_btn",
            "color": _vm.color,
            "disabled": !_vm.hasAnyGeoDevices,
            "tooltip": !_vm.hasAnyGeoDevices && _vm.$i18n_t('DigitalTwin.DigitalTwin.twinLoadMap') ? _vm.$i18n_t('DigitalTwin.DigitalTwin.twinLoadMapTooltip') : '',
            "prepend-icon": "fa-map-marked-alt",
            "to": "/virtual-devices/map"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinLoadMap')) + "\n        ")])], 1)];
      },
      proxy: true
    }])
  }), _vm.accountFilterReady && _vm.listIsReadyToFetch ? _c('core-virtual-device-list', {
    ref: "list",
    staticClass: "px-3",
    attrs: {
      "favouriteFilterEnabled": _vm.favouriteFilter,
      "accounts": _vm.selectedAccounts,
      "initSearchItems": _vm.initSearchItems,
      "initOperator": _vm.initOperator,
      "searchTypes": _vm.searchTypes
    },
    on: {
      "update-selected-rows": _vm.updateRowsSelected,
      "loaded-favourite-filter": e => {
        _vm.favouriteFilter = e;
      },
      "search-updated": (items, operator) => {
        _vm.searchOperator = operator;
        _vm.searchItems = items;
      },
      "load-items": items => {
        _vm.setTotalCountItems(items);
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };